import {Injectable, ViewContainerRef, ComponentRef} from '@angular/core';
import {AlertComponent} from "../shared/alert/alert.component";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private router: Router) {
  }

  private rootViewContainer!: ViewContainerRef;
  private alertComponentRef!: ComponentRef<AlertComponent>;
  private idToNavigate: string | null = null;

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  showDynamicAlert(message: string, type: string, idToNavigate: string | null = null) {
    if (!this.rootViewContainer) {
      console.error('Root ViewContainerRef not set!');
      return;
    }
    // Clear any existing alert
    this.rootViewContainer.clear();
    // Create the component
    this.alertComponentRef = this.rootViewContainer.createComponent(AlertComponent);
    this.alertComponentRef.instance.message = message;
    this.alertComponentRef.instance.id = idToNavigate;
    this.alertComponentRef.instance.type = type;
    this.idToNavigate = idToNavigate; // Set the ID to navigate to

    // Subscribe to the close event
    this.alertComponentRef.instance.closeAlert.subscribe(() => {
      this.alertComponentRef.destroy();
    });
  }
}
